// import { null } from 'mathjs';
// import { null } from 'mathjs';
import { useState, useEffect, useRef } from "react";
import { API_BASE } from "../AppConfig";
import blank_card from "./crazypaving.jpg"; // Tell webpack this JS file uses this image
const { convertJobStateToIni } = require("./Common_Conversions");

export const PRODUCT_CATEGORIES = [
    "Steel Roofing",
    "PolyCarbonate Roofing",
    "Fibreglass Roofing",
    "Back Channel",
    "Gutters & Accessories",
    "Downpipes & Accessories",
    "Flashing",
    "Beams",
    "Brackets",
    "Connectors",
    "Hardware",
    "Miscellaneous Items",
];

export function RehydrateThumbnails(pricefile) {
    if (pricefile?.["thumbs"])
        for (let row_data of pricefile["data"]) {
            if (row_data?.Image_b64 && pricefile?.["thumbs"]?.[row_data?.Image_b64] !== undefined) {
                row_data.Image_b64 = pricefile["thumbs"][row_data?.Image_b64];
            }
        }
    return pricefile;
}

export function DegreesToRadians(degrees) {
    var pi = Math.PI;
    return degrees * (pi / 180);
}

export function GetRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export function GetColourArray(colourListString, colour_arrays) {
    let colours = [];
    if (!colourListString) return colours;
    if (typeof colourListString === "string") {
        if (colourListString in colour_arrays) colours = [...colour_arrays[colourListString]];
        else {
            colours = colourListString.split(",");
            colours.forEach(function (colour, index, array) {
                array[index] = colour.trim();
            });
        }
    } else if (Array.isArray(colourListString)) {
        for (let colour of colourListString) {
            let this_colours = GetColourArray(colour, colour_arrays);
            colours.push(...this_colours);
        }
    }
    return colours;
}

let base_url = null;
export function BaseURL(path = "") {
    if (base_url === null) {
        //
        const index = blank_card.indexOf("static");
        base_url = blank_card.substr(0, index);
        //
    }
    //
    return base_url + path;
}

export function GetHTMLColour(colour) {
    if (!colour) return ["", "", ""];
    colour = colour.trim();
    if (typeof colour === "object") return [colour, colour, "#000"];
    if (typeof colour === "string" && (colour.startsWith("#") || colour.startsWith("rgb")))
        return [colour, colour, "#000"];
    if (window?.config?.colour_map && window.config.colour_map[colour]) {
        return [
            window.config.colour_map[colour]["Col1"],
            window.config.colour_map[colour]["Col2"],
            window.config.colour_map[colour]["Contrast"],
        ];
    } else if (colourMap && colourMap[colour]) {
        return colourMap[colour].split(",");
    }
    return ["", "", ""];
}
export function GetColourAlpha(colour) {
    if (colour.startsWith("#")) return [1];
    if (window?.config?.colour_map[colour]) {
        return window.config.colour_map[colour].Opacity;
    } else if (colourMap[colour]) {
        let color_split = colourMap[colour].split(",");
        if (color_split.length > 3) return Number(color_split[3]);
    }
    return 1;
}

export function addArrayItem(array, action) {
    return [...array, action.item];
}
export function insertArrayItem(array, action) {
    return [...array.slice(0, action.index), action.item, ...array.slice(action.index)];
}
export function removeArrayItem(array, action) {
    return [...array.slice(0, action.index), ...array.slice(action.index + 1)];
}
export function updateObjectInArray(array, action) {
    return array.map((item, index) => {
        if (index !== action.index) {
            // This isn't the item we care about - keep it as-is
            return item;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
            ...item,
            ...action.item,
        };
    });
}

export function DistanceXYZ(x1, x2, y1, y2, z1 = 0, z2 = 0) {
    var dx = Number(x2) - Number(x1);
    var dy = Number(y2) - Number(y1);
    var dz = Number(z2) - Number(z1);

    let dis_end1 = Math.abs(Math.sqrt(dx * dx + dy * dy + dz * dz));
    return dis_end1;
}

export function getPointForRef(pnt_str) {
    let p1 = pnt_str.replace("(", "").replace(")", "").replaceAll(",", "/") + "/0";
    let p1_split = p1.split("/");
    return { x: toNumber(p1_split[0]), y: toNumber(p1_split[1]), z: toNumber(p1_split[2]) };
}

export function midPointRef(pnt_str) {
    let ref1_split = pnt_str.split(";");
    let p1 = getPointForRef(ref1_split[0]);
    let p2 = getPointForRef(ref1_split[1]);
    return { x: (p1.x + p2.x) / 2, y: (p1.y + p2.y) / 2, z: (p1.z + p2.z) / 2 };
}

export function IsClose(ref1, ref2, single_point_tol = 30, two_point_tol = 60, twod_only = true) {
    //

    if (!ref2) return false;
    var tol = single_point_tol;

    //format (xx/yy/zz);(xx/yy/zz)
    let ref1_split = ref1.split(";");
    if (ref1_split.length > 1) tol = two_point_tol;
    let p1 = ref1_split[0].replace("(", "").replace(")", "").replaceAll(",", "/") + "/0";
    let p1_split = p1.split("/");
    let ref2_split = ref2.split(";");
    let r1 = ref2_split[0].replace("(", "").replace(")", "").replaceAll(",", "/") + "/0";
    let r1_split = r1.split("/");

    let dis_end1 = tol + 1;
    if (p1_split.length > 2 && r1_split.length > 2) {
        var dx = Number(p1_split[0]) - Number(r1_split[0]);
        var dy = Number(p1_split[1]) - Number(r1_split[1]);
        var dz = Number(p1_split[2]) - Number(r1_split[2]);

        if (twod_only) dz = 0;

        //
        //
        dis_end1 = Math.abs(Math.sqrt(dx * dx + dy * dy + dz * dz));
    }

    let dis_end2 = 0;

    if (ref1_split.length > 1 && ref2_split.length > 1) {
        dis_end2 = tol + 1;
        let p2 = ref1_split[1].replace("(", "").replace(")", "").replaceAll(",", "/") + "/0";
        let p2_split = p2.split("/");
        let r2 = ref2_split[1].replace("(", "").replace(")", "").replaceAll(",", "/") + "/0";
        let r2_split = r2.split("/");

        if (p2_split.length > 2 && r2_split.length > 2) {
            dx = Number(p2_split[0]) - Number(r2_split[0]);
            dy = Number(p2_split[1]) - Number(r2_split[1]);
            dz = Number(p2_split[2]) - Number(r2_split[2]);

            if (twod_only) dz = 0;
        }

        dis_end2 = Math.abs(Math.sqrt(dx * dx + dy * dy + dz * dz));
    }

    if (dis_end1 < tol && dis_end2 < tol) return true;
    return false;
}

export function getItemFromArray(
    array,
    key,
    value,
    key2 = null,
    value2 = null,
    single_point_tol = 30,
    two_point_tol = 60,
    twod_only = true
) {
    if (!array) {
        //
        return null;
    }
    for (let item of array) {
        if (item[key] && item[key] === value) {
            return item;
        }
    }
    for (let item of array) {
        if (key2 && value2 && item[key2] && item[key2] === value2) {
            return item;
        }
    }
    for (let item of array) {
        if (item[key] && IsClose(item[key], value, single_point_tol, two_point_tol, twod_only)) {
            return item;
        }
        if (key2 && value2 && item[key2] && IsClose(item[key2], value2, single_point_tol, two_point_tol, twod_only)) {
            return item;
        }
    }
    return null;
}

export function ReplaceItemFromArray(array, key, value, new_data, key2 = null, value2 = null) {
    return array.map((item, index) => {
        if (item[key] !== null && item[key] === value) {
            return {
                ...item,
                ...new_data,
            };
        }
        if (key2 && item[key2] !== null && item[key2] === value2) {
            return {
                ...item,
                ...new_data,
            };
        }
        return item;
    });
}

export function RemoveItemFromArray(
    array,
    key,
    value,
    key2 = null,
    value2 = null,
    tol = 100,
    match_parameter = undefined,
    match_value = undefined
) {
    return array.filter((item) => {
        if (match_parameter && match_value !== undefined && item[match_parameter] !== match_value) return true; //keep
        if (item[key] === value) return false; // delete
        if (item[key] && IsClose(item[key], value, tol * 0.66, tol)) return false; // delete

        if (key2 && value2 !== null && item[key2] === value2) return false; // delete
        if (key2 && value2 && item[key2] && IsClose(item[key2], value2, tol * 0.66, tol)) return false; // delete

        return true; //keep
    });
}

export function ConvertListToString(array) {
    let outStr = "";
    for (var i = 0; i < array.length; i++) {
        outStr += array[i];
        if (i == array.length - 2) {
            outStr += " & ";
        } else if (i < array.length - 1) {
            outStr += ", ";
        }
    }
    return outStr;
}

export function radiansToDegrees(radians) {
    var pi = Math.PI;
    return toNumber(radians) / (pi / 180);
}
export function degreeToRadians(degrees) {
    var pi = Math.PI;
    return toNumber(degrees) * (pi / 180);
}
export function Cos(degrees) {
    return Math.cos(degreeToRadians(degrees));
}
export function Sin(degrees) {
    return Math.sin(degreeToRadians(degrees));
}
export function Tan(degrees) {
    return Math.tan(degreeToRadians(degrees));
}

export function isBoxBeam(beam) {
    switch (beam) {
        case "656508":
            return true;
        case "656510":
            return true;
        case "1086510":
            return true;
        case "1586510":
            return true;
        case "2086510":
            return true;
        case "FL100":
            return true;
        case "FL10011":
            return true;
        case "FL150":
            return true;
        case "FL15015":
            return true;
        case "FL200":
            return true;
        case "FL20020":
            return true;
        default:
            return false;
    }
}

export function ConvertCutoutNameForDecks(name) {
    if (name.includes("FrontLeft")) return name.replace("FrontLeft", "BackLeft");
    if (name.includes("FrontRight")) return name.replace("FrontRight", "FrontLeft");
    if (name.includes("BackLeft")) return name.replace("BackLeft", "BackRight");
    if (name.includes("BackRight")) return name.replace("BackRight", "FrontRight");
    return name;
}

// RoofSheet Specification
export const DESIGN_TYPES = {
    // matched to VQU
    FLAT: "Flat Roof",
    GALV_FLAT: "Galv Flat Roof",
    PITCHED: "Pitched Roof",
    GABLE_PORTAL: "Gable Hip Roof",
    DECK: "Flat Deck",
};

function QQajustmentsHandleBackAttached(
    back_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    rear_paat,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (back_attached) {
        let rear_attachment = ExistingStructure?.AttachmentType;
        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name ? obj?.Name?.includes("Back") : false;
            });
            if (items.length > 0 && items[0]?.FasciaType) rear_attachment = items[0]?.FasciaType;
        }

        if (rear_attachment.includes("Fascia") && (is_pitched || is_portal)) rear_attachment = "Beam";

        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS && rear_paat.length === 0) {
            rear_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Back");
            });
        }

        //

        // if (rear_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
        if (rear_attachment.includes("Flyover")) {
            this_area_data.SHAPE.Depth -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            rear_paat.length > 0 &&
            (rear_attachment.includes("Fascia") || rear_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Depth -= fascia_beam_width;
        } else if (rear_attachment.includes("Beam") || rear_attachment.includes("Riser")) {
            if (is_portal) {
                //
                if (rear_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterB === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 2) {
                    this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterB === 1) {
                    this_area_data.SHAPE.Depth += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Depth += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Depth += attachment_Gutter_width;
            }
        }
    } else {
        if (is_flat) {
            if (this_area_data.SHAPE.SheetDirection === "Front" || this_area_data.SHAPE.SheetDirection === "Back") {
                if (this_area_data.SHAPE?.OH_Back > 0) {
                    this_area_data.SHAPE.Depth += Number(this_area_data.SHAPE?.OH_Back);
                }
            }
        }
    }
}

function QQajustmentsHandleFrontAttached(
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (this_area_data?.ATTACHMENTS?.AttachmentBottom === 1 && fascia_beam_width) {
        let front_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Front");
            });
            if (items.length > 0 && items[0]?.FasciaType) front_attachment = items[0]?.FasciaType;
        }
        if (front_attachment.includes("Fascia") && (is_pitched || is_portal)) front_attachment = "Beam";

        let front_paat = [];
        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS) {
            front_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Front");
            });
        }

        // if (front_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
        if (front_attachment.includes("Flyover")) {
            this_area_data.SHAPE.Depth -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            front_paat.length > 0 &&
            (front_attachment.includes("Fascia") || front_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Depth -= fascia_beam_width;
        } else if (front_attachment.includes("Beam") || front_attachment.includes("Riser")) {
            // this_area_data.SHAPE.Depth += attachment_Gutter_width;
            // if (is_portal && current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;

            if (is_portal) {
                if (front_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterF === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 2) {
                        this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 1) {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Depth += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 2) {
                    this_area_data.SHAPE.Depth += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterF === 1) {
                    this_area_data.SHAPE.Depth += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Depth += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Depth += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Depth += attachment_Gutter_width;
            }
        }
    } else {
        if (is_flat) {
            if (this_area_data.SHAPE.SheetDirection === "Front" || this_area_data.SHAPE.SheetDirection === "Back") {
                if (this_area_data.SHAPE?.OH_Front > 0) {
                    this_area_data.SHAPE.Depth += Number(this_area_data.SHAPE?.OH_Front);
                }
            }
        }
    }
}

function QQajustmentsHandleLeftAttached(
    left_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width
) {
    if (left_attached && fascia_beam_width) {
        let left_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Left");
            });
            if (items.length > 0 && items[0]?.FasciaType) left_attachment = items[0]?.FasciaType;
        }
        if (left_attachment.includes("Fascia") && (is_pitched || is_portal)) left_attachment = "Beam";

        let left_paat = [];
        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS) {
            left_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Left");
            });
        }

        if (left_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
            this_area_data.SHAPE.Length -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            left_paat.length > 0 &&
            (left_attachment.includes("Fascia") || left_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Length -= fascia_beam_width;
        } else if (left_attachment.includes("Beam") || left_attachment.includes("Riser")) {
            if (is_portal) {
                if (left_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterL === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 2) {
                    this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterL === 1) {
                    this_area_data.SHAPE.Length += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Length += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Length += attachment_Gutter_width;
            }
        }
    }
}

function QQajustmentsHandleRightAttached(
    right_attached,
    ExistingStructure,
    this_area_data,
    is_pitched,
    is_portal,
    site,
    fascia_beam_width,
    is_flat,
    attachment_BoxGutter_width,
    current_gutter_width,
    attachment_Gutter_width,
    right_paat
) {
    if (right_attached && fascia_beam_width) {
        let right_attachment = ExistingStructure?.AttachmentType;

        if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
            let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                return obj?.Name?.includes("Right");
            });
            if (items.length > 0 && items[0]?.FasciaType) right_attachment = items[0]?.FasciaType;
        }
        if (right_attachment.includes("Fascia") && (is_pitched || is_portal)) right_attachment = "Beam";

        if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS && right_paat.length === 0) {
            right_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                return obj?.Name?.includes("Right");
            });
        }

        if (right_attachment.includes("Flyover") || ExistingStructure?.AttachmentType === "Flyover") {
            this_area_data.SHAPE.Length -=
                site?.ExistingStructure.EaveDepth + site?.ExistingStructure.CladdingWidth + fascia_beam_width;
        } else if (
            is_flat &&
            right_paat.length > 0 &&
            (right_attachment.includes("Fascia") || right_attachment.includes("Wall"))
        ) {
            this_area_data.SHAPE.Length -= fascia_beam_width;
        } else if (right_attachment.includes("Beam") || right_attachment.includes("Riser")) {
            if (is_portal) {
                if (right_paat.length > 0) {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.AttachmentGutterR === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                } else {
                    if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 2) {
                        this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                    } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 1) {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                        if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                    } else {
                        this_area_data.SHAPE.Length += attachment_Gutter_width;
                    }
                }
            } else if (is_pitched) {
                let pitched_outset = attachment_Gutter_width;
                if (
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth &&
                    this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth > pitched_outset
                )
                    pitched_outset = Number(this_area_data?.GABLE_PARAMETERS?.SoakerFlashingWidth);

                if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 2) {
                    this_area_data.SHAPE.Length += attachment_BoxGutter_width;
                } else if (this_area_data?.GUTTERS_AND_DOWNPIPES?.GutterR === 1) {
                    this_area_data.SHAPE.Length += pitched_outset;
                    if (current_gutter_width) this_area_data.SHAPE.Length += current_gutter_width;
                } else {
                    this_area_data.SHAPE.Length += pitched_outset;
                }
            } else {
                this_area_data.SHAPE.Length += attachment_Gutter_width;
            }
        }
    }
}

export function checkValuesAreNull(obj) {
    for (var key in obj) {
        if (typeof obj[key] === "object") {
            if (!checkValuesAreNull(obj[key])) return false;
        } else if (obj[key] !== null && obj[key] != "") return false;
    }
    return true;
}

export function getNonNullValues(obj, values = null) {
    if (values === null) values = [];
    for (var key in obj) {
        if (typeof obj[key] === "object") {
            values = getNonNullValues(obj[key], values);
        } else if (obj[key] !== null && obj[key] != "") values.push(obj[key]);
    }
    return values;
}

function CloneFunction() {
    var that = this;
    var temp = function temporary() {
        return that.apply(this, arguments);
    };
    for (var key in this) {
        if (this.hasOwnProperty(key)) {
            temp[key] = this[key];
        }
    }
    return temp;
}

function setAll(obj, val) {
    if (!obj) {
        return obj;
    } else if (typeof obj === "object") {
        Object.keys(obj).forEach(function (index) {
            if (typeof obj[index] === "object") {
                setAll(obj[index], val);
            } else obj[index] = val;
        });
    } else {
        obj = val;
    }
    return obj;
}
export function setNull(obj) {
    let new_obj = deepCopy(obj);
    //
    //
    new_obj = setAll(new_obj, null);
    //
    return new_obj;
}

export function checkDoesObjectHaveContent(object) {
    for (const [key, value] of Object.entries(object)) {
        if (value && typeof value === "object") {
            // );
            let result = checkDoesObjectHaveContent(value);
            if (result) {
                // );
                return result;
            }
        } else if (value || value === 0) {
            // );
            return {
                key: key,
                value: value,
            };
        }
    }
    return false;
}

export function get(obj, key, def = undefined) {
    let val = key.split(".").reduce(function (o, x) {
        return typeof o === "undefined" || o === null ? o : o[x];
    }, obj);
    return val === undefined ? def : val;
}

export function Contains(value, values_to_check) {
    if (typeof values_to_check === "string") {
        return value.includes(values_to_check);
    }
    if (Array.isArray(values_to_check)) {
        for (let val of values_to_check) {
            if (value.includes(val)) return true;
        }
    }
    return false;
}

export function hashCode(value) {
    if (!value) return -1;
    var hash = 0,
        i,
        chr;
    for (i = 0; i < value.length; i++) {
        chr = value.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export function isTrue(value, value2 = null, value3 = null) {
    let val = isThisTrue(value);
    let val2 = isThisTrue(value2);
    let val3 = isThisTrue(value3);
    return val | val2 | val3;
}
export function isThisTrue(value) {
    if (value === undefined) return false;
    if (value === null) return false;
    if (typeof value === "string") {
        if (value === "1") return true;
        if (value.toUpperCase() === "TRUE") return true;
    }
    if (value === 1) return true;
    if (value === true) return true;
    return false;
}

export function toBool(value) {
    return isThisTrue(value);
}

const cbMap = {
    Monument: "#363638",
};

export const defaultColour = (desc, category, brand) => {
    let def_colour = "Colorbond";
    if (category === "Beams" && brand === "CDS") def_colour = "Centenary Beam Colours";
    else if (category === "Beams" && brand === "LLD") def_colour = "Lysaght Beam Colours";
    else if (category === "Beams") def_colour = "Beam Colours";

    if (desc.toUpperCase().includes("PLAIN")) def_colour = "Plain";
    else if (desc.toUpperCase().includes("GALV")) def_colour = "Galvanised";
    else if (desc.toUpperCase().includes("ZINCALUME")) def_colour = "Zincalume";
    else if (desc.toUpperCase().includes("ZINC")) def_colour = "Zinc";
    else if (desc.toUpperCase().includes("STAINLESS STEEL")) def_colour = "Stainless Steel";
    else if (desc.toUpperCase().includes("OPAL")) def_colour = "Opal";
    return def_colour;
};

// //// TOP OF THE SHEET / BOTTOM OF THE SHEET/ CONTRAST TEXT COLOUR
export const colourMap = {};
//   "OTHER": "#00FC00,#00FC00,#F5F5F5,1",
//   "TBA": "#F8AAD1,#F8AAD1,#000000,1",
//   "NONE": "#E0E0E5,#E0E0E5,#000000,1",
//   "Blue Ridge": "#6070A3,#6070A3,#F5F5F5,1",
//   "Bushland": "#89897C,#89897C,#F5F5F5,1",
//   "Classic Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Cottage Green": "#335142,#335142,#F5F5F5,1",
//   "Deep Ocean": "#474F60,#474F60,#F5F5F5,1",
//   "Dune": "#B2AEA2,#B2AEA2,#000000,1",
//   "Headland": "#96543F,#96543F,#F5F5F5,1",
//   "Ironstone": "#565960,#565960,#F5F5F5,1",
//   "Jasper": "#7F6D5B,#7F6D5B,#F5F5F5,1",
//   "Manor Red": "#BC4235,#BC4235,#F5F5F5,1",
//   "Night Sky": "#232326,#232326,#F5F5F5,1",
//   "Pale Eucalypt": "#77A577,#77A577,#000000,1",
//   "Paperbark": "#CCBFA8,#CCBFA8,#000000,1",
//   "Plantation": "#566360,#566360,#F5F5F5,1",
//   "Sandbank": "#CEB787,#CEB787,#000000,1",
//   "Shale Grey": "#BCBCBA,#BCBCBA,#000000,1",
//   "Surfmist": "#E0E0DD,#E0E0DD,#000000,1",
//   "Wilderness": "#63776B,#63776B,#F5F5F5,1",
//   "Windspray": "#919696,#919696,#000000,1",
//   "Woodland Grey": "#5B5B56,#5B5B56,#F5F5F5,1",
//   "Galvanised": "#E0E0E5,#E0E0E5,#000000,1",
//   "Zincalume": "#E0E0E5,#E0E0E5,#000000,1",
//   "Galvanised": "#E0E0E5,#E0E0E5,#000000,1",
//   "Zinc": "#E0E0E5,#E0E0E5,#000000,1",
//   "Arctic White/Arctic White": "#FCFCFC,#FCFCFC,#000000,1",
//   "Rich Cream/Rich Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Sahara/Sahara": "#CEB787,#CEB787,#000000,1",
//   "Vanilla/Vanilla": "#E9DCB8,#E9DCB8,#000000,1",
//   "Vanilla/Heritage Red": "#E9DCB8,#BC4235,#F5F5F5,1",
//   "Vanilla/Rivergum": "#E9DCB8,#63776B,#F5F5F5,1",
//   "Vanilla/Slate Grey": "#E9DCB8,#B5AFAA,#000000,1",
//   "Arctic White": "#FCFCFC,#FCFCFC,#000000,1",
//   "Graphite": "#5B5B56,#5B5B56,#F5F5F5,1",
//   "Heritage Green": "#335142,#335142,#F5F5F5,1",
//   "Hunter Red": "#BC4235,#BC4235,#F5F5F5,1",
//   "Rich Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Sahara": "#CEB787,#CEB787,#000000,1",
//   "Vanilla": "#E9DCB8,#E9DCB8,#000000,1",
//   "Opal": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Gumleaf": "#4C7A4F,#4C7A4F,#F5F5F5,1",
//   "Ocean Blue": "#638291,#638291,#F5F5F5,1",
//   "Classic Cream": "#FCF4BC,#FCF4BC,#000000,1",
//   "Grey Tint (Trans)": "#565960,#565960,#F5F5F5,0.8",
//   "Bronze Tint (Trans)": "#7F6D5B,#7F6D5B,#F5F5F5,0.8",
//   "Clear (Trans)": "#E0E0E5,#E0E0E5,#000000,0.5",
//   "Opal": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Platinum (Trans)": "#566360,#566360,#F5F5F5,1",
//   "Steel (Trans)": "#565960,#565960,#F5F5F5,1",
//   "Olive Mica (Trans)": "#63776B,#63776B,#F5F5F5,1",
//   "Gun Metal (Trans)": "#6d6c6e,#6d6c6e,#F5F5F5,1",
//   "Eucalypt": "#63776B,#63776B,#F5F5F5,1",
//   "Alpine Blue": "#638291,#638291,#F5F5F5,1",
//   "Satin Cream": "#CCBFA8,#CCBFA8,#000000,1",
//   "Satin Sage": "#63776B,#63776B,#F5F5F5,1",
//   "Designer Light TWO": "#E0E0E5,#E0E0E5,#000000,1",
//   "Metallic Ice TWO": "#FCFCFC,#FCFCFC,#000000,1",
//   "Metallic Grey TWO": "#6d6c6e,#6d6c6e,#F5F5F5,1",
//   "Grey Tint TWO": "#565960,#565960,#F5F5F5,1",
//   "Clear Tint": "#E0E0E5,#E0E0E5,#000000,0.8",
//   "Aqua Tint": "#638291,#638291,#F5F5F5,1",
//   "Grey Tint": "#565960,#565960,#F5F5F5,1",
//   "Metallic Grey": "#6d6c6e,#6d6c6e,#F5F5F5,0.9",
//   "Opal Tint": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Clear Tint": "#E0E0E5,#E0E0E5,#000000,0.8",
//   "Grey Tint": "#565960,#565960,#F5F5F5,0.9",
//   "Stone": "#FCC6BC,#FCC6BC,#000000,1",
//   "Arctic Ice": "#FCFCFC,#FCFCFC,#000000,1",
//   "Metallic Bronze (Trans)": "#8E6638,#8E6638,#F5F5F5,1",
//   "Ivory": "#CEB787,#CEB787,#000000,1",
//   "Cream (Fibreglass)": "#E9DCB8,#E9DCB8,#000000,1",
//   "Pale Eucalypt/Surfmist": "#77A577,#E0E0DD,#000000,1",
//   "Pale Terracotta/Surfmist": "#E0E0DD,#E0E0DD,#000000,1",
//   "Classic Cream/Surfmist": "#E9DCB8,#E0E0DD,#000000,1",
//   "Paperbark/Surfmist": "#CCBFA8,#E0E0DD,#000000,1",
//   "Surfmist/Surfmist": "#E0E0DD,#E0E0DD,#000000,1",
//   "Sahara/Slate Grey": "#CEB787,#BDBEB9,#000000,1",
//   "Cedar Bronze ST": "#8E6638,#8E6638,#F5F5F5,1",
//   "Clear ST": "#E0E0E5,#E0E0E5,#000000,0.5",
//   "Mist Green ST": "#63776B,#63776B,#F5F5F5,1",
//   "Opal ST": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Smooth Cream ST": "#FCF4BC,#FCF4BC,#000000,1",
//   "Solar Grey ST": "#565960,#565960,#F5F5F5,1",
//   "Grey ST": "#565960,#565960,#F5F5F5,1",
//   "Diffused Grey ST": "#565960,#565960,#F5F5F5,1",
//   "Diffused Ice ST": "#FCFCFC,#FCFCFC,#000000,1",
//   "Evening Haze": "#C4C2A9,#C4C2A9,#000000,1",
//   "Loft": "#232326,#232326,#F5F5F5,1",
//   "Monument": cbMap.Monument + "," + cbMap.Monument + ",#F5F5F5,1",
//   "Pitch Black": "#232326,#232326,#F5F5F5,1",
//   "Stone": "#FCC6BC,#FCC6BC,#000000,1",
//   "Bronze Olive": "#7F6D5B,#7F6D5B,#F5F5F5,1",
//   "Zincalume/Grey": "#E0E0E5,#BDBEB9,#000000,1",
//   "Blue Ridge/Grey": "#6070A3,#BDBEB9,#000000,1",
//   "Bushland/Grey": "#89897C,#BDBEB9,#000000,1",
//   "Classic Cream/Grey": "#E9DCB8,#BDBEB9,#000000,1",
//   "Cottage Green/Grey": "#335142,#BDBEB9,#F5F5F5,1",
//   "Deep Ocean/Grey": "#474F60,#BDBEB9,#F5F5F5,1",
//   "Dune/Grey": "#B2AEA2,#BDBEB9,#000000,1",
//   "Evening Haze/Grey": "#C4C2A9,#BDBEB9,#000000,1",
//   "Headland/Grey": "#96543F,#BDBEB9,#000000,1",
//   "Ironstone/Grey": "#565960,#BDBEB9,#F5F5F5,1",
//   "Jasper/Grey": "#7F6D5B,#BDBEB9,#F5F5F5,1",
//   "Loft/Grey": "#232326,#BDBEB9,#000000,1",
//   "Manor Red/Grey": "#BC4235,#BDBEB9,#F5F5F5,1",
//   "Monument/Grey": cbMap.Monument + ",#BDBEB9,#F5F5F5,1",
//   "Night Sky/Grey": "#232326,#BDBEB9,#F5F5F5,1",
//   "Pale Eucalypt/Grey": "#77A577,#BDBEB9,#000000,1",
//   "Paperbark/Grey": "#CCBFA8,#BDBEB9,#000000,1",
//   "Plantation/Grey": "#566360,#BDBEB9,#000000,1",
//   "Sandbank/Grey": "#CEB787,#BDBEB9,#000000,1",
//   "Shale Grey/Grey": "#BCBCBA,#BDBEB9,#000000,1",
//   "Surfmist/Grey": "#E0E0DD,#BDBEB9,#000000,1",
//   "Wilderness/Grey": "#63776B,#BDBEB9,#000000,1",
//   "Windspray/Grey": "#919696,#BDBEB9,#000000,1",
//   "Woodland Grey/Grey": "#5B5B56,#BDBEB9,#F5F5F5,1",
//   "Heritage Red": "#BC4235,#BC4235,#F5F5F5,1",
//   "Slate Grey": "#B5AFAA,#B5AFAA,#000000,1",
//   "Dune/Surfmist": "#B2AEA2,#E0E0DD,#000000,1",
//   "Headland/Surfmist": "#96543F,#E0E0DD,#000000,1",
//   "Clear": "#E0E0E5,#E0E0E5,#000000,0.6",
//   "Light Bronze": "#7F6D5B,#7F6D5B,#F5F5F5,0.8",
//   "Grey": "#565960,#565960,#F5F5F5,0.8",
//   "Opal": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Green": "#63776B,#63776B,#F5F5F5,1",
//   "Wheat": "#B5AFAA,#B5AFAA,#000000,1",
//   "Dark Tint": "#232326,#232326,#F5F5F5,0.8",
//   "Smooth Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Mist Green": "#63776B,#63776B,#F5F5F5,1",
//   "Pearl Ice": "#FCFCFC,#FCFCFC,#000000,0.93",
//   "Silver Mist": "#C8C6CA,#C8C6CA,#000000,0.93",
//   "Plain": "#E0E0DD,#E0E0DD,#000000,1",
//   "Bronze": "#7F6D5B,#7F6D5B,#F5F5F5,0.93",
//   "Grey": "#565960,#565960,#F5F5F5,0.8",
//   "Metallic Grey": "#565960,#565960,#F5F5F5,0.9",
//   "Opal": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Grey": "#565960,#565960,#F5F5F5,0.8",
//   "Opal": "#FCFCFC,#FCFCFC,#000000,0.9",
//   "Rivergum": "#63776B,#63776B,#F5F5F5,1",
//   "Domain": "#E9DCB8,#E9DCB8,#000000,1",
//   "Terrace": "#CEB787,#CEB787,#000000,1",
//   "Riversand": "#CEB787,#CEB787,#000000,1",
//   "Willow": "#77A577,#77A577,#000000,1",
//   "Grey Ridge": "#5B5B56,#5B5B56,#F5F5F5,1",
//   "Basalt": "#6d6c6e,#6d6c6e,#F5F5F5,1",
//   "Cove": "#89897C,#89897C,#F5F5F5,1",
//   "Gully": "#7F7F72,#7F7F72,#F5F5F5,1",
//   "Mangrove": "#737562,#737562,#F5F5F5,1",
//   "Terrain": "#67432E,#67432E,#F5F5F5,1",
//   "Wallaby": "#7F7F72,#7F7F72,#F5F5F5,1",
//   "Basalt/Grey": "#6d6c6e,#B5AFAA,#F5F5F5,1",
//   "Cove/Grey": "#89897C,#B5AFAA,#F5F5F5,1",
//   "Gully/Grey": "#7F7F72,#B5AFAA,#F5F5F5,1",
//   "Mangrove/Grey": "#737562,#B5AFAA,#F5F5F5,1",
//   "Terrain/Grey": "#67432E,#B5AFAA,#F5F5F5,1",
//   "Wallaby/Grey": "#7F7F72,#B5AFAA,#F5F5F5,1",
//   "Classic Cream/Classic Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Paperbark/Gully": "#CCBFA8,#7F7F72,#F5F5F5,1",
//   "Gully/Paperbark": "#7F7F72,#CCBFA8,#F5F5F5,1",
//   "Classic Cream/Mangrove": "#E9DCB8,#737562,#F5F5F5,1",
//   "Classic Cream/Monument": "#E9DCB8," + cbMap.Monument + ",#F5F5F5,1",
//   "Paperbark/Paperbark": "#CCBFA8,#CCBFA8,#000000,1",
//   "Surfmist/Surfmist": "#E0E0DD,#E0E0DD,#000000,1",
//   "Classic Cream/Woodland Grey": "#E9DCB8,#5B5B56,#F5F5F5,1",
//   "Paperbark/Woodland Grey": "#CCBFA8,#5B5B56,#F5F5F5,1",
//   "Woodland Grey/Paperbark": "#5B5B56,#CCBFA8,#F5F5F5,1",
//   "Basalt/Surfmist": "#6d6c6e,#E0E0DD,#F5F5F5,1",
//   "Jasper/Surfmist": "#7F6D5B,#E0E0DD,#F5F5F5,1",
//   "Shale Grey/Surfmist": "#BCBCBA,#E0E0DD,#000000,1",
//   "Surfmist/Monument": "#E0E0DD," + cbMap.Monument + ",#F5F5F5,1",
//   "Monument/Surfmist": cbMap.Monument + ",#E0E0DD,#F5F5F5,1",
//   "Woodland Grey/Surfmist": "#5B5B56,#E0E0DD,#F5F5F5,1",
//   "Pale Eucalypt/Classic Cream": "#77A577,#E9DCB8,#000000,1",
//   "Classic Cream/Classic Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Paperbark/Classic Cream": "#CCBFA8,#E9DCB8,#F5F5F5,1",
//   "Surfmist/Classic Cream": "#E0E0DD,#E9DCB8,#000000,1",
//   "Dune/Classic Cream": "#B2AEA2,#E9DCB8,#F5F5F5,1",
//   "Headland/Classic Cream": "#96543F,#E9DCB8,#000000,1",
//   "Basalt/Classic Cream": "#6d6c6e,#E9DCB8,#F5F5F5,1",
//   "Jasper/Classic Cream": "#7F6D5B,#E9DCB8,#000000,1",
//   "Shale Grey/Classic Cream": "#BCBCBA,#E9DCB8,#F5F5F5,1",
//   "Woodland Grey/Classic Cream": "#5B5B56,#E9DCB8,#F5F5F5,1",
//   "Mangrove/Classic Cream": "#737562,#E9DCB8,#F5F5F5,1",
//   "Monument/Classic Cream": cbMap.Monument + ",#E9DCB8,#F5F5F5,1",
//   "Classic Cream": "#E9DCB8,#E9DCB8,#000000,1",
//   "Surfmist": "#E0E0DD,#E0E0DD,#000000,1",
//   "Pale Terracotta/Classic Cream": "#E0E0DD,#E9DCB8,#000000,1",
//   "Monument/Monument": cbMap.Monument + "," + cbMap.Monument + ",#F5F5F5,1",
//   "Classic Cream/Manor Red": "#E9DCB8,#BC4235,#F5F5F5,1",
//   "Manor Red/Classic Cream": "#BC4235,#E9DCB8,#F5F5F5,1",
//   "White": "#FFFFFF,#FFFFFF,#000000,1",
//   "Pearl White": "#FFFFFF,#FFFFFF,#000000,1",
//   "Basalt/Pearl White": "#6d6c6e,#FFFFFF,#F5F5F5,1",
//   "Dune/Pearl White": "#B2AEA2,#FFFFFF,#F5F5F5,1",
//   "Manor Red/Pearl White": "#BC4235,#FFFFFF,#F5F5F5,1",
//   "Paperbark/Pearl White": "#CCBFA8,#FFFFFF,#F5F5F5,1",
//   "Shale Grey/Pearl White": "#BCBCBA,#FFFFFF,#F5F5F5,1",
//   "Surfmist/Pearl White": "#E0E0DD,#FFFFFF,#000000,1",
//   "Windspray/Pearl White": "#919696,#FFFFFF,#000000,1",
//   "Woodland Grey/Pearl White": "#5B5B56,#FFFFFF,#F5F5F5,1",
// }

export function toDecimal(value, allow_negative = true) {
    return toNumber(value, allow_negative);
}
export function toNumber(value, allow_negative = true, allow_decimal = true) {
    if (typeof value === "number") return value;
    if (!value) return 0;
    if (value.replace) {
        let neg = false;
        if (allow_negative && value.includes("-")) neg = true;
        let str = value.replace(/[^0-9.]/g, "").split(".");
        let form_str = (neg ? "-" : "") + str[0] + (allow_decimal && str.length > 1 ? "." + str[1] : "");
        return Number(form_str);
    }
    return Number(value);
}

export const toAUD = (val) => {
    return toNumber(val).toLocaleString("en-AU", { style: "currency", currency: "AUD" });
};

export const CreateIntegerRange = (start, end, step) => {
    start = toNumber(start);
    end = toNumber(end);
    let result = [];
    if (end <= start) {
        result.push(start);
        return result;
    }
    step = toNumber(step);

    return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), (x) => start + x * step);
};

export const replaceVariables = (area_data, range) => {
    let new_range = { ...range };

    if (!area_data) return range;
    for (var key in new_range) {
        if (area_data && typeof new_range[key] === "string" && new_range[key].startsWith("Area.")) {
            let value = get(area_data, new_range[key].replace("Area.", ""));
            if (value) new_range[key] = value;
        }
    }
    return new_range;
};

export async function fetchTimeout(url, options, timeout = 36000) {
    let base_options = {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "text/plain",
        },
        redirect: "follow", // manual0., *follow, error
        referrer: "no-referrer", // no-referrer, *client
    };

    let merged_options = { ...base_options, ...options };

    if (window.debug) {
        merged_options.headers["X-CDS_token"] = getCookie("CDS_token");
    }

    if (!window.fetchTimeoutCompleted) {
        window.fetchTimeoutCompleted = {};
    }

    if (options.retry) {
        return Promise.race([
            new Promise((resolveFetch, reject) => {
                fetch(url, merged_options)
                    .then((fetch_response) => {
                        if (fetch_response.status >= 200 && fetch_response.status <= 300) {
                            if (options.request_id) {
                                window.fetchTimeoutCompleted[options.request_id] = true;
                            }
                            resolveFetch(fetch_response);
                        } else {
                            setTimeout(
                                () => reject(new Error("error in response")),
                                options.retry_timeout ? timeout + options.retry_timeout : timeout
                            );
                        }
                    })
                    .catch((error) => {
                        if (error.message.includes("aborted a request"))
                            window.fetchTimeoutCompleted[options.request_id] = true;
                        console.error("fetchTimeout error", error);
                    });
            }),
            new Promise((resolveFetch, reject) =>
                setTimeout(() => {
                    if (window.fetchTimeoutCompleted[options.request_id]) {
                    } else {
                        fetch(url, { ...merged_options, signal: null })
                            .then((fetch_response) => {
                                if (options.request_id) {
                                    window.fetchTimeoutCompleted[options.request_id] = true;
                                }

                                resolveFetch(fetch_response);
                            })
                            .catch((error) => {
                                console.error("fetch SOS error", error);
                            });
                    }
                }, timeout)
            ),
            new Promise((_, reject) =>
                setTimeout(
                    () => reject(new Error("timeout")),
                    options.retry_timeout ? timeout + options.retry_timeout : timeout
                )
            ),
        ]).catch((error) => {
            console.error("fetchTimeout error", error);
        });
    } else {
        return Promise.race([
            fetch(url, merged_options),
            new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), timeout)),
        ]).catch((error) => {
            console.error("fetchTimeout error", error);
        });
    }
}

export function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
}

// Our hook
export default function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            // Set debouncedValue to value (passed in) after the specified delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            // Return a cleanup function that will be called every time ...
            // ... useEffect is re-called. useEffect will only be re-called ...
            // ... if value changes (see the inputs array below).
            // This is how we prevent debouncedValue from changing if value is ...
            // ... changed within the delay period. Timeout gets cleared and restarted.
            // To put it in context, if the user is typing within our app's ...
            // ... search box, we don't want the debouncedValue to update until ...
            // ... they've stopped typing for more than 500ms.
            return () => {
                clearTimeout(handler);
            };
        },
        // Only re-call effect if value changes
        // You could also add the "delay" var to inputs array if you ...
        // ... need to be able to change that dynamically.
        [value]
    );

    return debouncedValue;
}

export function ReplaceAll(target, search, replacement) {
    return target.replace(new RegExp(search, "g"), replacement);
}

export function GetPromptCode(key, prompt_codes_string) {
    var return_val = null;
    if (!prompt_codes_string) return null;
    // $.each(prompt_codes_string.match(/(?:[^\s"]+|"[^"]*")+/g), function (index, element) {

    prompt_codes_string.match(/(?:[^\s"]+|"[^"]*")+/g).forEach((element) => {
        var pair = element.split("=");
        if (pair[1] && pair[0] === key) {
            return_val = ReplaceAll(pair[1], '"', "");
        }
    });
    return return_val;
}

export function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest function.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

export const updateLayoutAll = (job_data, app) => {
    // let job_data = getState().job;

    let job_ini = convertJobStateToIni(job_data, app);
    let id = job_data.id;

    fetchTimeout(API_BASE() + "svg/" + id + "/display", {
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            job: job_ini,
            area_index: -1,
            brand: window.LYSAGHT ? "Lysaght" : "Fielders",
        }),
    })
        .then(async (response) => {})
        .catch((e) => {
            // handle errors and timeout error
        }); // parses JSON response into native Javascript objects
};

export const saveJobBasic = (job, bom = false, user_data = false) => {
    if (!job || !job.id) {
        return;
    }

    if (job?.App?.Locked) {
    }

    let savejob_url = API_BASE() + "job/" + job.id;
    var save_job = deepCopy(job);
    if (!bom && save_job?.QuoteParameters?.BOM) {
        save_job.QuoteParameters.BOM = null;
    }

    if (user_data)
        //&& !user_data.id.includes("diego.portela"))
        save_job.LastEditor = {
            id: user_data.id,
            DisplayName: user_data.DisplayName,
            UserCode: user_data.UserCode,
            _session_id: window?.session_id,
            _ts: Date.now(),
        };

    save_job.ErrorMap = {};
    //
    return (
        fetchTimeout(savejob_url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            body: JSON.stringify(save_job), // body data type must match "Content-Type" header
        })
            // .then(async response => {let new_response = {text: await response.text()}; return new_response})
            .then(async (response) => {
                if (response.status === 422) {
                    let error_map = JSON.parse(await response.text());
                } else if (response.status >= 200 && response.status < 300) {
                    //
                } else {
                }
            })
            .catch((e) => {
                // handle errors and timeout error
            })
    ); // parses JSON response into native Javascript objects
};

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

    return "#" + RR + GG + BB;
}

export function deepCopy(obj) {
    var rv;

    switch (typeof obj) {
        case "object":
            if (obj === null) {
                // null => null
                rv = null;
            } else {
                switch (toString.call(obj)) {
                    case "[object Array]":
                        // It's an array, create a new array with
                        // deep copies of the entries
                        rv = obj?.map(deepCopy);
                        break;
                    case "[object Date]":
                        // Clone the date
                        rv = new Date(obj);
                        break;
                    case "[object RegExp]":
                        // Clone the RegExp
                        rv = new RegExp(obj);
                        break;
                    case "[object Function]":
                        // Clone the Function
                        rv = CloneFunction(obj);
                        break;
                    // ...probably a few others
                    default:
                        // Some other kind of object, deep-copy its
                        // properties into a new object
                        rv = Object.keys(obj).reduce(function (prev, key) {
                            prev[key] = deepCopy(obj[key]);
                            return prev;
                        }, {});
                        break;
                }
            }
            break;
        default:
            // It's a primitive, copy via assignment
            rv = obj;
            break;
    }
    return rv;
}

export const setCookie = (name, value, days = 7, path = "/") => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=" + path;
};

export const getCookie = (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, "");
};

export const deleteCookie = (name, path) => {
    setCookie(name, "", -1, path);
};

export const extractRefsFromSVG = (selType) => {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(window?.svg_data, "image/svg+xml");
    const polygons = svgDoc.querySelectorAll("polygon");
    const refValues = [];

    polygons.forEach((polygon) => {
        const id = polygon.getAttribute("id");

        if (id && id.includes(`sel_type:${selType}`)) {
            const match = id.match(/ref:(\([^)]+\))/);

            if (match) {
                refValues.push(match[1]);
            }
        }
    });

    return refValues;
};

export const objectByString = (o, s) => {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    //
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    // );
    return o;
};

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function encodeJobNumber(jobNumber) {
    const base64 = btoa(encodeURIComponent(jobNumber));
    const reversed = base64.split("").reverse().join("");
    return "X" + reversed + "Y";
}

export function checkValidJSON(str) {
    if (!str) return false;
    if (typeof str === "object") {
        return true;
    }
    if (!str) {
        return false;
    }
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
    return true;
}

export function convertRoleCodeToName(code) {
    if (code == 99) return "super";
    else if (code >= 92) return "engineer";
    else if (code >= 91) return "state admin";
    else if (code >= 90) return "bbc";
    else if (code >= 10) return "admin";
    else return "";
}
